import { describeResource } from '@siteless/resource';
import { doc, getDoc } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';

let PreviousYearResultOrderResource = describeResource<undefined, string[]>(
  'PreviousYearResultOrder',
  {
    get: async () => {
      let docSnap = await getDoc(
        doc(database, 'objective_state', String(thisOscarsYear - 1)),
      );
      let data = docSnap.data();
      if (!data?.results) return [];
      return (data.results as Record<string, string>[]).map(
        item => Object.keys(item)[0],
      );
    },
  },
);

export default PreviousYearResultOrderResource;
